import * as actionTypes from "./constants";


const fetchCountry = () => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_PROFILECOUNTRY_ACTION,
    });
  };
};

const fetchregion = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_REGION_ACTION,
      params: params,
    });
  };
};

const fetchlocation = (params) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.FETCH_LOCATION_ACTION,
      params: params,
    });
  };
};

const addshipperprofile = (value) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_SHIPPERPROFILE_ACTION,
      value: value,
    });
  };
};

const addshipperImg = (value) => {
  return (dispatch) => {
    dispatch({
      type: actionTypes.ADD_SHIPPER_IMG_INIT_ACTION,
      value: value,
    });
  };
};

export default {
  fetchCountry,
  fetchregion,
  fetchlocation,
  addshipperprofile,
  addshipperImg
};
